import { Component, computed, input, output } from '@angular/core';
import { MatTooltipModule, TooltipPosition } from '@angular/material/tooltip';
import { ISlotBarSlot, TSlotBarSize } from './slot-bar.interface';
import { getBarToneBackground, getSlotBarLayout, SLOT_BAR_GAP } from './slot-bar.util';

/**
 * Row of fixed-width blocks, one per slot ("n of m" discrete progress). Bars given the same `capacity` share one grid,
 * so their blocks line up across rows. Projected content (the label) follows the bar. Clickable slots render as
 * buttons and emit their index.
 */
@Component({
  imports: [MatTooltipModule],
  selector: 'app-slot-bar',
  styleUrl: './slot-bar.component.scss',
  templateUrl: './slot-bar.component.html',
})
export class SlotBarComponent {
  public readonly slots = input.required<ISlotBarSlot[]>();
  public readonly size = input<TSlotBarSize>('regular');
  /** Blocks the bar is sized for (the longest bar it lines up with); 0 = this bar's own slot count. */
  public readonly capacity = input<number>(0);
  /** Side of the block tooltips, e.g. away from a card that covers the other side. */
  public readonly tooltipPosition = input<TooltipPosition>('above');

  public readonly slotClick = output<number>();

  public readonly hasClickableSlots = computed(() => this.slots().some((slot) => slot.clickable));
  public readonly layout = computed(() => getSlotBarLayout(Math.max(this.capacity(), this.slots().length)));

  public readonly gap = SLOT_BAR_GAP;
  public readonly getBarToneBackground = getBarToneBackground;
}
